// @flow
import type { SeoTrack } from "@tvg/types/Track";

export type State = {
  prevPath: string,
  trackCode: string,
  raceNumber: string,
  isRaceDataShown: boolean,
  isBeta: boolean,
  hasConnection: boolean,
  hasShownForceUpdate: boolean,
  isIOSEventsSubsRunning: boolean,
  selectedState: string,
  openLoginRetryCounter: number,
  hasCrossNavigation: boolean,
  subscription: string,
  seoTrackList: SeoTrack[]
};

export const initialState = {
  prevPath: "",
  trackCode: "",
  raceNumber: "",
  isRaceDataShown: false,
  isBeta: false,
  hasConnection: true,
  hasShownForceUpdate: false,
  showStateSelector: false,
  isIOSEventsSubsRunning: false,
  promosList: [],
  selectedState: "",
  openLoginRetryCounter: 0,
  hasCrossNavigation: false,
  subscription: "",
  seoTrackList: []
};

type Action = {
  payload: boolean | string,
  type: string
};

export default function appReducer(
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case "PROMOS_LIST_SET": {
      return { ...state, promosList: action.payload };
    }
    case "SET_BETA_OPTIN": {
      return { ...state, isBeta: action.payload };
    }
    case "SET_HAS_CONNECTION": {
      return { ...state, hasConnection: action.payload };
    }
    case "SET_SELECTED_STATE": {
      return { ...state, selectedState: action.payload };
    }
    case "SET_PREV_PATH": {
      return { ...state, prevPath: action.payload };
    }
    case "SET_HAS_CROSS_NAVIGATION": {
      return { ...state, hasCrossNavigation: action.payload };
    }
    case "SET_SEO_TRACK_LIST": {
      return { ...state, seoTrackList: action.payload };
    }
    default: {
      return state;
    }
  }
}
